import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

function DataProtectionStatement({ language, handleNavigation }) {
  const { t } = useTranslation();
  // Please review and accept the Terms and Conditions. This is required before you can continue.

  const getTermsStatement = () => {
    if (language === 'en') {
      return (
        <>
          <div className="form-group">
            {t('startPage.statement')}
            &nbsp;
            <a href="/terms" className="btn-link" onClick={handleNavigation}>
              {t('startPage.termsAndConditions')}
            </a>
            {t('startPage.statement2')}
          </div>
        </>
      );
    }
    return (
      <>
        <div className="form-group">
          {t('startPage.statement')}
          <a href="/terms" className="btn-link" onClick={handleNavigation}>
            {t('startPage.termsAndConditions')}
          </a>
          .
        </div>
      </>
    );
  };

  return (
    <>
      {getTermsStatement()}
      <div className="form-group">
        {t('startPage.seeOur')}
        &nbsp;
        <a href={t('startPage.privacyPolicyUrl')} className="btn-link">
          {t('startPage.privacyPolicy')}
        </a>
        &nbsp;
        {t('startPage.and')}
        &nbsp;
        <a href={t('startPage.legalNoticeUrl')} className="btn-link">
          {t('startPage.legalNotice')}
        </a>
        .
      </div>
    </>
  );
}

DataProtectionStatement.propTypes = {
  language: PropTypes.string.isRequired,
  handleNavigation: PropTypes.func.isRequired,
};

export default DataProtectionStatement;
